import type {
    CartItem,
    CartMailSetting
} from "@/api/modules/autoQ/checkout/types.ts";

export const INITIAL_CUSTOM_MAIL_CONTENTS: CartMailSetting = {
    mailSettingText: "",
    mailSettingSubject: ""
} as const;

export const INITIAL_CART_ITEM: CartItem = {
    cartItemUuid: "",
    status: "",
    sentAt: null,
    mailSender: {
        label: "",
        value: 0,
    },
    documents: [],
    uploadedDocuments: [],
    predefinedDocuments: [],
    customer: null,
    mailCustomSubject: null,
    mailCustomText: null,
    recipients: [],
};